module.exports = __webpack_public_path__ + "img/canales-punto-red.cde14507.svg";